import { use } from 'react';

import { LbOptionsContext } from '../model/store';

export const useOptions = () => use(LbOptionsContext);
